export default __webpack_public_path__ + "static/media/fNeutral12.478eaad3.png";